import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import { ICommissionHistoryItem } from '@interfaces/organisation/organisations';

import { ECommissionType } from './constants';

export const getColumns = () => {
	return [
		{
			header: 'Start date',
			accessorKey: 'date',
			enableSorting: false,
			cell: ({ getValue }: CellContext<ICommissionHistoryItem, any>) => {
				const value = getValue();
				const text = value ? value.slice(0, 10) : '';

				return <AdaptiveTableCell text={text} />;
			},
		},
		{
			header: 'Commission type',
			accessorKey: 'commissionType',
			enableSorting: false,
			cell: ({ getValue }: CellContext<ICommissionHistoryItem, any>) => {
				const value = getValue();

				return <AdaptiveTableCell text={value} />;
			},
		},
		{
			header: 'Value',
			accessorKey: 'value',
			enableSorting: false,
			cell: ({ getValue, row }: CellContext<ICommissionHistoryItem, any>) => {
				const value = getValue();
				const unit = row.original.commissionType === ECommissionType.fixed ? '£' : '%';
				const text = `${value}${unit}`;

				return <AdaptiveTableCell text={text} />;
			},
		},
	];
};

export default getColumns;
